import { render, staticRenderFns } from "./index.vue?vue&type=template&id=280dd2dd&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=280dd2dd&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=280dd2dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280dd2dd",
  null
  
)

export default component.exports